module.exports = __webpack_public_path__ + "static/media/banner3.96213c97.jpg";